import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { useState } from 'react';

export const useDownloadPdf = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadPdf = async () => {
    const inputElement = document.getElementById('root');

    if (!inputElement) return;

    setIsLoading(true);

    // Use html2canvas to capture a snapshot
    html2canvas(inputElement)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');

        // Initialize jsPDF
        const pdf = new jsPDF('p', 'mm', 'a4');

        // Add image to PDF
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        // Save PDF
        pdf.save('snapshot.pdf');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return { handleDownloadPdf, isLoading };
};
